<template>
  <div>
    <div v-if="!loadingData">
      <div class="parent-table">
        <div v-if="loading" class="loading">
          <v-progress-linear indeterminate color="primary darken-2"></v-progress-linear>
        </div>
        <div style="width: 350px;">
          <InventoryInforBasic :items="itemsBasic" @onSearch="data => onSearch(data)" />
        </div>
        <div style="width: calc(100% - 430px);">
          <InventoryInfoAdvanced @mappingDone="() => this.$emit('mappingDone')" />
        </div>
        <div style="width: 80px;">
          <InventoryTableActions
            v-if="$auth.policies['import-deliveries:save-schedules']"
            @onRefresh="() => $emit('onRefresh')"
          />
        </div>
      </div>
      <v-data-footer
        items-per-page-text="Số dữ liệu mỗi trang"
        @update:options="pagination => onPaginationChange(pagination)"
        :items-per-page-options="[10, 20, 50]"
        :options="{
          page: page,
          itemsPerPage: itemsPerPage
        }"
        :pagination="{
          page: page,
          itemsPerPage,
          pageStart: (page - 1) * itemsPerPage,
          pageStop: page * itemsPerPage,
          itemsLength: itemsLength
        }"
      >
      </v-data-footer>
    </div>
    <div v-else class="loading-screen">
      <div class="text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <div class="mt-2">{{ 'Đang tải bảng ...' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import InventoryInfoAdvanced from './InventoryInfoAdvanced.vue'
import InventoryInforBasic from './InventoryInforBasic.vue'
import InventoryTableActions from './InventoryTableActions.vue'
export default {
  components: {
    InventoryInfoAdvanced,
    InventoryInforBasic,
    InventoryTableActions
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('importDeliveries', ['inventory', 'countProduct']),
    itemsLength() {
      if (this.countProduct) return this.countProduct
      return 0
    }
  },
  data() {
    return {
      itemsBasic: [],
      page: 1,
      itemsPerPage: 10,
      pageStart: 0,
      pageStop: 10,
      searchParams: {},
      loadingData: true
    }
  },
  created() {
    setTimeout(() => {
      this.loadingData = false
    }, 2500)
  },
  methods: {
    onPaginationChange(page) {
      this.itemsPerPage = page.itemsPerPage
      this.page = page.page
      this.onRefresh()
    },
    async onRefresh() {
      this.$emit('onRefresh', {
        _start: (this.page - 1) * this.itemsPerPage,
        _limit: this.itemsPerPage,
        code_contains: get(this.searchParams, 'code_contains', ''),
        description_contains: get(this.searchParams, 'description_contains', '')
      })
    },
    onSearch(data) {
      this.searchParams = data
      this.$emit('onSearch', {
        _start: (this.page - 1) * this.itemsPerPage,
        _limit: this.itemsPerPage,
        ...data
      })
    }
  },
  watch: {
    inventory: {
      handler(val) {
        if (Array.isArray(val)) {
          this.itemsBasic = val.map(v => ({
            code: get(v, 'code', ''),
            description: get(v, 'description', ''),
            quantity: get(v, 'quantity', '')
          }))
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/assets/delivery/table-inventory.scss';
</style>
